import { create } from 'zustand';
import { AboutPageSettingData } from '../dto/EntityRepository';
import type { ResourceScope, ResourceStatus } from '../util/scopedResource';

interface AboutPageSettingState {
  aboutPageSetting: AboutPageSettingData | null;
  settingOwnerAui: string | null;
  settingScope: ResourceScope | null;
  status: ResourceStatus;
  beginAboutPageSettingFetch: (ownerAui: string, scope: ResourceScope) => void;
  setAboutPageSetting: (
    value: AboutPageSettingData,
    ownerAui: string,
    scope: ResourceScope,
  ) => void;
  setAboutPageSettingError: () => void;
  clearAboutPageSetting: () => void;
}

export const useAboutPageSettingStore = create<AboutPageSettingState>((set) => ({
  aboutPageSetting: null,
  settingOwnerAui: null,
  settingScope: null,
  status: 'idle',
  beginAboutPageSettingFetch: (ownerAui, scope) => set((state) => {
    if (
      state.settingOwnerAui === ownerAui &&
      state.settingScope === scope &&
      state.status === 'success'
    ) {
      return state;
    }
    return { status: 'loading' };
  }),
  // AboutPageSetting에 필드가 추가돼도 응답 전체가 항상 반영되도록 교체한다.
  setAboutPageSetting: (value, ownerAui, scope) => set({
    aboutPageSetting: value,
    settingOwnerAui: ownerAui,
    settingScope: scope,
    status: 'success',
  }),
  setAboutPageSettingError: () => set({ status: 'error' }),
  clearAboutPageSetting: () => set((state) => {
    if (
      state.aboutPageSetting === null &&
      state.settingOwnerAui === null &&
      state.settingScope === null &&
      state.status === 'idle'
    ) {
      return state;
    }
    return {
      aboutPageSetting: null,
      settingOwnerAui: null,
      settingScope: null,
      status: 'idle',
    };
  }),
}));
